import { CancelButton } from '@core/components/Buttons';
import { SimpleDialogCommon } from '@core/components/Dialog';
import SimpleDialogCommonContent from '@core/components/Dialog/SimpleDialogCommonContent';
import { SearchBar } from '@core/components/SearchBar';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Button, Divider, List, ListItem, ListItemText, MenuItem, Select, Typography } from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import { EmpresaModais } from 'app/main/empresa/modal';
import { confirmarAlert } from 'app/services/alerts';
import empresaApi from 'app/services/api/empresaApi';
import * as Actions from 'app/store/actions';
import * as MessageActions from 'app/store/actions/fuse/message.actions';
import { GlobalContext } from 'app/store/globalcontext';
import { eventReactGA } from 'app/utils/analyticsUtil';
import { encrypt, getEmpresaContexto } from 'app/utils/geralUtil';
import React, { useContext, useEffect, useState } from 'react';
import { FaBuilding } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selecionarEmpresaStyles } from './styles/Styles';

const ModalSelecionarEmpresa = () => {
  const classes = selecionarEmpresaStyles();
  const [search, setSearch] = useState('');
  const [registros, setRegistros] = useState([]);
  const [, setNomeEmpresa] = useContext(GlobalContext).nomeEmpresa;
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [last, setLast] = useState(0);
  const history = useHistory();
  const [modal, setModal] = useContext(GlobalContext).modal;

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);
  const [loading, setLoading] = useState(false);

  useReduxLoading(loading);

  const closeModal = () => {
    setModal('');
  };

  const chamarModalAlterarPlano = () => {
    setModal(EmpresaModais.alteracaoPlanoComercial);
  };

  const confirmarAlteracaoPlano = () => {
    confirmarAlert({
      confirmar: chamarModalAlterarPlano,
      titulo: 'Seu plano atual não permite cadastro de mais empresas.',
      mensagem: 'Você deseja conhecer mais sobre esses planos?',
    });
  };

  const handleNovoCadastroModal = async () => {
    if (permissaoUtils.minhaEmpresa().visualizar) {
      try {
        await empresaApi.limiteEmpresa(true);
        history.push('/empresa');
        closeModal();
      } catch (err) {
        confirmarAlteracaoPlano();
      }
    } else {
      dispatch(
        MessageActions.showMessage({ message: 'Você não possui permissão para acessar esta tela.', variant: 'error' })
      );
    }
  };

  const filtro = {
    page,
    size: pageSize,
    sort: 'pessoa.nome,asc',
    query: '',
    ativo: true,
  };

  useEffect(() => {
    filtrarEmpresaSelecionar();
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    filtrarEmpresaSelecionar();
    // A função é recriada a cada render; incluí-la reexecutaria a busca em loop.
    // O efeito depende apenas do gatilho listado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const filtrarEmpresaSelecionar = (_page, _pageSize) => {
    filtro.query = search;
    filtro.size = _pageSize || pageSize;
    filtro.page = _page >= 0 ? _page : page;

    setLoading(true);

    empresaApi
      .modalEmpresaSelecionar(filtro)
      .then((resp) => {
        setRegistros(resp?.data?.content);
        setTotalElements(resp?.data?.totalElements);
        setTotalPages(resp?.data?.totalPages);
        setLast(resp?.data?.last);
      })
      .catch((error) => {
        setLoading(false);
        apiUtils.handleApiError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const atualizarEmpresaContexto = (empresaId, nomeEmpresa) => {
    setLoading(true);

    eventReactGA('Empresa', 'Alterar empresa do contexto atual');
    empresaApi
      .atualizarEmpresaContexto(empresaId)
      .then((resp) => {
        if (resp.status === 200) {
          localStorage.setItem('EC', encrypt(empresaId));
          setNomeEmpresa(nomeEmpresa);
          history.push('/visao-geral');
          window.location.reload();
          filtrarEmpresaSelecionar();
        }
      })
      .catch((error) => {
        setLoading(false);
        apiUtils.handleApiError(error);
      })
      .finally(() => {
        setLoading(false);
      });
    closeModal();
  };

  return (
    <SimpleDialogCommon open={modal === EmpresaModais.modalSelecionarEmpresa} onClose={closeModal}>
      <SimpleDialogCommonContent
        header={
          <div className={classes.searchBarContainer}>
            <SearchBar
              onChange={setSearch}
              placeholder="Pesquisar empresa por CNPJ, Nome ou Razão social"
              className={classes.searchBar}
            />
            <div className={classes.buttonCancel}>
              <CancelButton onClick={closeModal}>Fechar</CancelButton>
            </div>
          </div>
        }
        content={
          <>
            {registros && !!registros?.length && (
              <div>
                <List>
                  {registros.map((empresa, index) => {
                    return (
                      <div key={`list-item-${index}`}>
                        <ListItem button onClick={() => atualizarEmpresaContexto(empresa?.id, empresa.pessoa.nome)}>
                          <ListItemText
                            disableTypography
                            primary={
                              <Typography
                                className={getEmpresaContexto().includes(empresa?.id) ? classes.listItem : ''}
                              >
                                {empresa?.pessoa?.nome}
                              </Typography>
                            }
                          />
                        </ListItem>
                        <Divider />
                      </div>
                    );
                  })}
                </List>
              </div>
            )}

            <div>
              <Button className={classes.buttonGerenciar} onClick={handleNovoCadastroModal}>
                <span style={{ padding: '5px' }}>
                  <FaBuilding />
                </span>
                Gerenciar/Adicionar empresas
              </Button>
            </div>

            <div className={classes.paginationContainer}>
              <div className={classes.pagination}>
                <div className="mr-32">Registros por página:</div>

                <div>
                  <Select
                    className={classes.select}
                    value={pageSize}
                    onChange={(event) => {
                      setPageSize(event.target.value); // assincrono
                      filtrarEmpresaSelecionar(undefined, event.target.value);
                    }}
                    autoWidth
                    disableUnderline
                  >
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                    <MenuItem value={60}>60</MenuItem>
                  </Select>
                </div>

                <div>
                  {page * pageSize + 1}-{' '}
                  {totalElements <= pageSize ? totalElements : last ? totalElements : pageSize * (page + 1)} de{' '}
                  {totalElements}
                </div>

                <div>
                  <Pagination
                    count={totalPages}
                    shape="rounded"
                    onChange={(_, number) => {
                      setPage(number - 1); // assincrono
                      filtrarEmpresaSelecionar(number - 1);
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        }
      />
    </SimpleDialogCommon>
  );
};

export default ModalSelecionarEmpresa;
